import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from '@massds/mayflower-react';

const Pager = (props) => {
  const buildPagerProps = () => {
    const { page } = props;
    const pages = [];
    const spacer = {
      active: false,
      text: 'spacer'
    };
    const totalPages = Math.min(Math.ceil(props.totalResults / 10), 10);
    // Only first three pages follow this pattern.
    if (page < 4) {
      for (let i = 1; i <= (Math.min(3, totalPages)); i += 1) {
        pages.push({
          active: i === page,
          text: i.toString(),
          onClick: props.handlePageClick,
          ariaLabel: `${'Go to search results page '}${i.toString()}`
        });
      }
      // Only show spacer if there are >3 subsequent pages.
      if (totalPages > (page + 3)) {
        pages.push(spacer);
      }
    } else {
      // Always include 1
      pages.push({
        active: false,
        text: '1',
        onClick: props.handlePageClick,
        ariaLabel: 'Go to search results page 1'
      });
      // Spacer
      pages.push(spacer);
      for (let i = (page - 1); i <= (page + 1); i += 1) {
        if (i <= totalPages) {
          pages.push({
            active: i === page,
            text: i.toString(),
            onClick: props.handlePageClick,
            ariaLabel: `${'Go to search results page '}${i.toString()}`
          });
        }
      }
      if ((page + 1) < totalPages) {
        pages.push(spacer);
      }
    }
    return{
      next: {
        disabled: (page >= totalPages),
        text: 'Next',
        onClick: props.handleNextClick,
        ariaLabel: 'Go to the next search results page'
      },
      prev: {
        disabled: (page <= 1),
        text: 'Previous',
        onClick: props.handlePrevClick,
        ariaLabel: 'Go to the previous search results page'
      },
      pages
    };
  };
  const paginationProps = buildPagerProps();
  return(
    <Pagination {...paginationProps} />
  );
};

Pager.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  page: PropTypes.number,
  totalResults: PropTypes.number,
  handlePageClick: PropTypes.func,
  handleNextClick: PropTypes.func,
  handlePrevClick: PropTypes.func
};


export default Pager;
